import React from "react";

const ProfileCompletion = ({progress, onCompleteProfile}) => {
  return (
    <div className="w-full flex items-center gap-4 p-2 bg-[#f0f7ff] rounded-xl shadow-sm">
      {/* Circular Progress Bar */}
      <div className="relative flex items-center justify-center w-14 h-14">
        <svg className="w-full h-full" viewBox="0 0 36 36">
          <circle
            cx="18"
            cy="18"
            r="15.9155"
            fill="transparent"
            stroke="#e6e6e6"
            strokeWidth="3"
          />
          <circle
            cx="18"
            cy="18"
            r="15.9155"
            fill="transparent"
            stroke="#1A64B9"
            strokeWidth="3"
            strokeDasharray={`${progress}, 100`}
            strokeLinecap="round"
            transform="rotate(-90 18 18)"
          />
        </svg>
        <span className="absolute text-[#1A64B9] font-semibold text-xs 2xl:text-sm">
          {progress}%
        </span>
      </div>

      {/* Text and Button */}
      <div className="flex flex-col">
        <span className="text-[#19295C] font-semibold text-xs 2xl:text-sm leading-3">
          Avancement du profil
        </span>
        <button
          onClick={onCompleteProfile}
          className="mt-2 px-2 py-1 bg-[#FFEDD9] text-[#FF6600] text-nowrap font-medium text-[10px] rounded-lg flex items-center justify-center gap-1"
        >
          Compléter mon profil
          <span className="text-[#FF6600]">
            <i className="fi fi-rr-arrow-up-right items-center flex"></i>
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProfileCompletion;
